import React, { useState, useEffect } from 'react';
import ProductItem from './ProductItem';
import ProductFilter from './ProductFilter';
import './ProductList.css';

const ProductList = ({ products, fetchProducts, onEdit, categories = [] }) => {
    const [filteredProducts, setFilteredProducts] = useState(products);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        let filtered = products;

        // Filtrar por categoría si se selecciona una
        if (selectedCategory) {
            filtered = filtered.filter(product => product.category._id === selectedCategory);
        }

        // Filtrar por nombre si se ingresa un término de búsqueda
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(product => product.name.toLowerCase().includes(term));
        }

        setFilteredProducts(filtered);
    }, [selectedCategory, searchTerm, products]);

    return (
        <div className="product-list-container">
            {/* Filtro de productos */}
            <ProductFilter 
                categories={categories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            />

            {/* Lista de productos filtrados */}
            {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                    <ProductItem 
                        key={product._id} 
                        product={product} 
                        fetchProducts={fetchProducts} 
                        onEdit={onEdit} 
                    />
                ))
            ) : (
                <p>No hay productos disponibles.</p>
            )}
        </div>
    );
};

export default ProductList;
